import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, ...props }) => {
  // Verhindert den Absturz des Bundlers, da wir auf "import * as FiIcons" verzichten.
  // Das ist möglich, da alle Komponenten das Icon-Objekt direkt übergeben.
  if (!IconComponent) {
    return <FiAlertTriangle {...props} />;
  }
  
  return <IconComponent {...props} />;
};

export default SafeIcon;